import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersV, faProjectDiagram, faSitemap, faAlienMonster, faEclipse } from '@fortawesome/pro-duotone-svg-icons';
import { TabPaneKey } from '../OpsCenterView';
import OpsCenterLink from '../OpsCenterLink';
import routes from 'src/routes';

export namespace ConfigurationTab {
  export const key = '/nucleus/configuration' satisfies TabPaneKey;

  export const header = (
    <>
      <FontAwesomeIcon icon={faSlidersV} /> Configuration
    </>
  );

  type ContentProps = {
    isAnonAdmin: boolean | null;
    isRaClientMng: boolean | null;
    isRaMatchAttMng: boolean | null;
    isRaSiteMng: boolean | null;
  };

  export const Content: React.FC<ContentProps> = ({
    isAnonAdmin,
    isRaClientMng,
    isRaMatchAttMng,
    isRaSiteMng,
  }) => {
    return (
      <>
        {isRaClientMng && (
          <OpsCenterLink to={routes.configureClient} icon={faProjectDiagram}>
            Client Management
          </OpsCenterLink>
        )}
        {isRaSiteMng && (
          <OpsCenterLink to={routes.configureSite} icon={faSitemap}>
            Site Management
          </OpsCenterLink>
        )}
        {isRaMatchAttMng && (
          <OpsCenterLink to={routes.matchAttribute} icon={faAlienMonster}>
            Match Attribute <br />
            Management
          </OpsCenterLink>
        )}
        {isAnonAdmin && (
          <OpsCenterLink to={routes.configureAnonProxySettings} icon={faEclipse}>
            Anonymity Management
          </OpsCenterLink>
        )}
      </>
    );
  };
}
